import type {ImageType} from "../types";

import {useCookie, useRuntimeConfig} from "nuxt/app";
import {computed} from "vue";
import {useHydrated} from "./use-hydrated";

const defaultImageType: ImageType = "model";

export function usePreferredProductImageType() {
	const {
		public: {nodeEnv},
	} = useRuntimeConfig();

	const cookie = useCookie<ImageType>("preferred-product-image-type", {
		default: () => defaultImageType,
		maxAge: 60 * 60 * 24 * 365, // 1 year
		// These should be default on all cookies
		sameSite: "lax",
		secure: nodeEnv === "production",
	});

	const hydrated = useHydrated();

	// Server-rendered pages may be cached and served to other visitors, so always render
	// them with the default image type and apply the visitor's preference after
	// hydration.
	return computed<ImageType>({
		get: () => (hydrated.value ? cookie.value : defaultImageType),
		set: (value) => {
			cookie.value = value;
		},
	});
}
